export default "__VITE_ASSET__DAT3QIvs__"